Link = require('react-router-dom').Link
RouteHandler = require('react-router-dom').RouteHandler

# Provides global navigation for app e.g. the "Hello | Styleguide" at the top.
module.exports = class App extends React.Component
  displayName: 'App'
  render: =>
    <div>
    </div>
